module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uEngWZqjKcxgUdMjV5wG839",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "uNEbxupCvYmnN9xQAedxfRC"
    }
  }), _vm._v("Introduction by Paul “Punch” Stanimirovic")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I became a diamond thief to make my father proud of me. For a glorious period in the 1990s, I was King of the New York streets until SWAT teams, helicopters, hundreds of police officers, and one smart dog, captured me. They couldn’t keep me, and they couldn’t stop me.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I walked out of jail and hid in plain sight for four years using dozens of names and identities, hosting lavish events, and hanging out with superstars. If I were to name-drop every show-business celebrity who visited my home, partied in my nightclub, or went skiing with me in the Swiss Alps, the combined weight would tear through this page, or knock the screen off your Kindle, Nook, or Kobo.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There are days when I only remember the thrill of the heist, the pulse-pounding excitement of slithering down the back of 47"), _c('sup', {
    staticClass: "superscript _idGenCharOverride-2"
  }, [_vm._v("th")]), _vm._v(" Street in Manhattan as a black-attired heist-ninja backed up by my hand-picked crew of professionals dedicated to my father’s precision planning.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I’m sure you’re curious about my dad, the man I regard as a true genius. Had he been caught doing a heist, he would already be famous. Now, he will be. Who else pulled off mega-heists totaling over one billion dollars and got away with it? Nobody.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My mother? Oh, she is beautiful and fabulous. I want you to really get to know my parents, charming and sophisticated outlaws, who honestly got away with everything. This is their story, and mine, as told by our friend and confidant, Burl Barer.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9ce8f40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Intro.vue
// module id = 78
// module chunks = 0